/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    DigitizingserviceMelcoDigitizingModelsCopyOrderToAppRequest,
    DigitizingserviceMelcoDigitizingModelsCopyOrderToAppRequestFromJSON,
    DigitizingserviceMelcoDigitizingModelsCopyOrderToAppRequestToJSON,
    DigitizingserviceMelcoDigitizingModelsCopyOrderToAppResponse,
    DigitizingserviceMelcoDigitizingModelsCopyOrderToAppResponseFromJSON,
    DigitizingserviceMelcoDigitizingModelsCopyOrderToAppResponseToJSON,
    DigitizingserviceMelcoDigitizingModelsOrderAlertSubmit,
    DigitizingserviceMelcoDigitizingModelsOrderAlertSubmitFromJSON,
    DigitizingserviceMelcoDigitizingModelsOrderAlertSubmitToJSON,
    DigitizingserviceMelcoDigitizingModelsOrderAlertSubmitResponse,
    DigitizingserviceMelcoDigitizingModelsOrderAlertSubmitResponseFromJSON,
    DigitizingserviceMelcoDigitizingModelsOrderAlertSubmitResponseToJSON,
    DigitizingserviceMelcoDigitizingModelsOrderAssetsReplace,
    DigitizingserviceMelcoDigitizingModelsOrderAssetsReplaceFromJSON,
    DigitizingserviceMelcoDigitizingModelsOrderAssetsReplaceToJSON,
    DigitizingserviceMelcoDigitizingModelsOrderCreate,
    DigitizingserviceMelcoDigitizingModelsOrderCreateFromJSON,
    DigitizingserviceMelcoDigitizingModelsOrderCreateToJSON,
    DigitizingserviceMelcoDigitizingModelsOrderPublish,
    DigitizingserviceMelcoDigitizingModelsOrderPublishFromJSON,
    DigitizingserviceMelcoDigitizingModelsOrderPublishToJSON,
    DigitizingserviceMelcoDigitizingModelsOrderResponse,
    DigitizingserviceMelcoDigitizingModelsOrderResponseFromJSON,
    DigitizingserviceMelcoDigitizingModelsOrderResponseToJSON,
    DigitizingserviceMelcoDigitizingModelsOrderSave,
    DigitizingserviceMelcoDigitizingModelsOrderSaveFromJSON,
    DigitizingserviceMelcoDigitizingModelsOrderSaveToJSON,
    DigitizingserviceMelcoDigitizingModelsSewOutPricingResponse,
    DigitizingserviceMelcoDigitizingModelsSewOutPricingResponseFromJSON,
    DigitizingserviceMelcoDigitizingModelsSewOutPricingResponseToJSON,
    DigitizingserviceMelcoDigitizingModelsTempOrderCompleteRequest,
    DigitizingserviceMelcoDigitizingModelsTempOrderCompleteRequestFromJSON,
    DigitizingserviceMelcoDigitizingModelsTempOrderCompleteRequestToJSON,
    DigitizingserviceMelcoModelsError,
    DigitizingserviceMelcoModelsErrorFromJSON,
    DigitizingserviceMelcoModelsErrorToJSON,
    DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsOrderAlert,
    DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsOrderAlertFromJSON,
    DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsOrderAlertToJSON,
    DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsOrderListItem,
    DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsOrderListItemFromJSON,
    DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsOrderListItemToJSON,
} from '../models';

export interface DigitizingServiceOrdersApiDigitizeCopyToAppRequest {
    productCode: string;
    digitizingserviceMelcoDigitizingModelsCopyOrderToAppRequest?: DigitizingserviceMelcoDigitizingModelsCopyOrderToAppRequest;
}

export interface DigitizingServiceOrdersApiDigitizeCreateRequest {
    digitizingserviceMelcoDigitizingModelsOrderCreate?: DigitizingserviceMelcoDigitizingModelsOrderCreate;
}

export interface DigitizingServiceOrdersApiDigitizeDeleteRequest {
    id: string;
}

export interface DigitizingServiceOrdersApiDigitizeDownloadFileRequest {
    id: string;
    format?: string;
}

export interface DigitizingServiceOrdersApiDigitizeGetRequest {
    id: string;
}

export interface DigitizingServiceOrdersApiDigitizeGetAlertListRequest {
    id: string;
}

export interface DigitizingServiceOrdersApiDigitizeGetListRequest {
    offset?: number;
    limit?: number;
    sortBy?: string;
    searchText?: string;
    orderStatusList?: string;
}

export interface DigitizingServiceOrdersApiDigitizeGetSewOutPricingRequest {
    width?: string;
    height?: string;
    deliveryOptionId?: string;
    measurementUnit?: string;
}

export interface DigitizingServiceOrdersApiDigitizePublishRequest {
    id: string;
    digitizingserviceMelcoDigitizingModelsOrderPublish?: DigitizingserviceMelcoDigitizingModelsOrderPublish;
}

export interface DigitizingServiceOrdersApiDigitizeReplaceAssetsRequest {
    id: string;
    digitizingserviceMelcoDigitizingModelsOrderAssetsReplace?: DigitizingserviceMelcoDigitizingModelsOrderAssetsReplace;
}

export interface DigitizingServiceOrdersApiDigitizeSubmitAlertRequest {
    id: string;
    digitizingserviceMelcoDigitizingModelsOrderAlertSubmit?: DigitizingserviceMelcoDigitizingModelsOrderAlertSubmit;
}

export interface DigitizingServiceOrdersApiDigitizeTempCompleteOrderRequest {
    id: string;
    digitizingserviceMelcoDigitizingModelsTempOrderCompleteRequest?: DigitizingserviceMelcoDigitizingModelsTempOrderCompleteRequest;
}

export interface DigitizingServiceOrdersApiDigitizeUpdateRequest {
    id: string;
    digitizingserviceMelcoDigitizingModelsOrderSave?: DigitizingserviceMelcoDigitizingModelsOrderSave;
}

/**
 * 
 */
export class DigitizingServiceOrdersApi extends runtime.BaseAPI {

    /**
     */
    async digitizeCopyToAppRaw(requestParameters: DigitizingServiceOrdersApiDigitizeCopyToAppRequest): Promise<runtime.ApiResponse<DigitizingserviceMelcoDigitizingModelsCopyOrderToAppResponse>> {
        if (requestParameters.productCode === null || requestParameters.productCode === undefined) {
            throw new runtime.RequiredError('productCode','Required parameter requestParameters.productCode was null or undefined when calling digitizeCopyToApp.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/digitize/copy/apps/{product_code}/copy`.replace(`{${"product_code"}}`, encodeURIComponent(String(requestParameters.productCode))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DigitizingserviceMelcoDigitizingModelsCopyOrderToAppRequestToJSON(requestParameters.digitizingserviceMelcoDigitizingModelsCopyOrderToAppRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DigitizingserviceMelcoDigitizingModelsCopyOrderToAppResponseFromJSON(jsonValue));
    }

    /**
     */
    async digitizeCopyToApp(requestParameters: DigitizingServiceOrdersApiDigitizeCopyToAppRequest): Promise<DigitizingserviceMelcoDigitizingModelsCopyOrderToAppResponse> {
        const response = await this.digitizeCopyToAppRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async digitizeCreateRaw(requestParameters: DigitizingServiceOrdersApiDigitizeCreateRequest): Promise<runtime.ApiResponse<DigitizingserviceMelcoDigitizingModelsOrderResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/digitize/orders`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DigitizingserviceMelcoDigitizingModelsOrderCreateToJSON(requestParameters.digitizingserviceMelcoDigitizingModelsOrderCreate),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DigitizingserviceMelcoDigitizingModelsOrderResponseFromJSON(jsonValue));
    }

    /**
     */
    async digitizeCreate(requestParameters: DigitizingServiceOrdersApiDigitizeCreateRequest): Promise<DigitizingserviceMelcoDigitizingModelsOrderResponse> {
        const response = await this.digitizeCreateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async digitizeDeleteRaw(requestParameters: DigitizingServiceOrdersApiDigitizeDeleteRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling digitizeDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/digitize/orders/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async digitizeDelete(requestParameters: DigitizingServiceOrdersApiDigitizeDeleteRequest): Promise<void> {
        await this.digitizeDeleteRaw(requestParameters);
    }

    /**
     */
    async digitizeDownloadFileRaw(requestParameters: DigitizingServiceOrdersApiDigitizeDownloadFileRequest): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling digitizeDownloadFile.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.format !== undefined) {
            queryParameters['format'] = requestParameters.format;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/digitize/orders/{id}/download`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async digitizeDownloadFile(requestParameters: DigitizingServiceOrdersApiDigitizeDownloadFileRequest): Promise<Blob> {
        const response = await this.digitizeDownloadFileRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async digitizeGetRaw(requestParameters: DigitizingServiceOrdersApiDigitizeGetRequest): Promise<runtime.ApiResponse<DigitizingserviceMelcoDigitizingModelsOrderResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling digitizeGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/digitize/orders/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DigitizingserviceMelcoDigitizingModelsOrderResponseFromJSON(jsonValue));
    }

    /**
     */
    async digitizeGet(requestParameters: DigitizingServiceOrdersApiDigitizeGetRequest): Promise<DigitizingserviceMelcoDigitizingModelsOrderResponse> {
        const response = await this.digitizeGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async digitizeGetAlertListRaw(requestParameters: DigitizingServiceOrdersApiDigitizeGetAlertListRequest): Promise<runtime.ApiResponse<DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsOrderAlert>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling digitizeGetAlertList.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/digitize/orders/{id}/alerts`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsOrderAlertFromJSON(jsonValue));
    }

    /**
     */
    async digitizeGetAlertList(requestParameters: DigitizingServiceOrdersApiDigitizeGetAlertListRequest): Promise<DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsOrderAlert> {
        const response = await this.digitizeGetAlertListRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async digitizeGetListRaw(requestParameters: DigitizingServiceOrdersApiDigitizeGetListRequest): Promise<runtime.ApiResponse<DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsOrderListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        if (requestParameters.orderStatusList !== undefined) {
            queryParameters['order_status_list'] = requestParameters.orderStatusList;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/digitize/orders`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsOrderListItemFromJSON(jsonValue));
    }

    /**
     */
    async digitizeGetList(requestParameters: DigitizingServiceOrdersApiDigitizeGetListRequest): Promise<DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsOrderListItem> {
        const response = await this.digitizeGetListRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async digitizeGetSewOutPricingRaw(requestParameters: DigitizingServiceOrdersApiDigitizeGetSewOutPricingRequest): Promise<runtime.ApiResponse<DigitizingserviceMelcoDigitizingModelsSewOutPricingResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.width !== undefined) {
            queryParameters['width'] = requestParameters.width;
        }

        if (requestParameters.height !== undefined) {
            queryParameters['height'] = requestParameters.height;
        }

        if (requestParameters.deliveryOptionId !== undefined) {
            queryParameters['delivery_option_id'] = requestParameters.deliveryOptionId;
        }

        if (requestParameters.measurementUnit !== undefined) {
            queryParameters['measurement_unit'] = requestParameters.measurementUnit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/digitize/orders/sew_out_pricing`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DigitizingserviceMelcoDigitizingModelsSewOutPricingResponseFromJSON(jsonValue));
    }

    /**
     */
    async digitizeGetSewOutPricing(requestParameters: DigitizingServiceOrdersApiDigitizeGetSewOutPricingRequest): Promise<DigitizingserviceMelcoDigitizingModelsSewOutPricingResponse> {
        const response = await this.digitizeGetSewOutPricingRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async digitizePublishRaw(requestParameters: DigitizingServiceOrdersApiDigitizePublishRequest): Promise<runtime.ApiResponse<DigitizingserviceMelcoDigitizingModelsOrderResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling digitizePublish.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/digitize/orders/{id}/publish`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DigitizingserviceMelcoDigitizingModelsOrderPublishToJSON(requestParameters.digitizingserviceMelcoDigitizingModelsOrderPublish),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DigitizingserviceMelcoDigitizingModelsOrderResponseFromJSON(jsonValue));
    }

    /**
     */
    async digitizePublish(requestParameters: DigitizingServiceOrdersApiDigitizePublishRequest): Promise<DigitizingserviceMelcoDigitizingModelsOrderResponse> {
        const response = await this.digitizePublishRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async digitizeReplaceAssetsRaw(requestParameters: DigitizingServiceOrdersApiDigitizeReplaceAssetsRequest): Promise<runtime.ApiResponse<DigitizingserviceMelcoDigitizingModelsOrderResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling digitizeReplaceAssets.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/digitize/orders/{id}/reset_asset`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DigitizingserviceMelcoDigitizingModelsOrderAssetsReplaceToJSON(requestParameters.digitizingserviceMelcoDigitizingModelsOrderAssetsReplace),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DigitizingserviceMelcoDigitizingModelsOrderResponseFromJSON(jsonValue));
    }

    /**
     */
    async digitizeReplaceAssets(requestParameters: DigitizingServiceOrdersApiDigitizeReplaceAssetsRequest): Promise<DigitizingserviceMelcoDigitizingModelsOrderResponse> {
        const response = await this.digitizeReplaceAssetsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async digitizeSubmitAlertRaw(requestParameters: DigitizingServiceOrdersApiDigitizeSubmitAlertRequest): Promise<runtime.ApiResponse<DigitizingserviceMelcoDigitizingModelsOrderAlertSubmitResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling digitizeSubmitAlert.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/digitize/orders/{id}/alerts`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DigitizingserviceMelcoDigitizingModelsOrderAlertSubmitToJSON(requestParameters.digitizingserviceMelcoDigitizingModelsOrderAlertSubmit),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DigitizingserviceMelcoDigitizingModelsOrderAlertSubmitResponseFromJSON(jsonValue));
    }

    /**
     */
    async digitizeSubmitAlert(requestParameters: DigitizingServiceOrdersApiDigitizeSubmitAlertRequest): Promise<DigitizingserviceMelcoDigitizingModelsOrderAlertSubmitResponse> {
        const response = await this.digitizeSubmitAlertRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async digitizeTempCompleteOrderRaw(requestParameters: DigitizingServiceOrdersApiDigitizeTempCompleteOrderRequest): Promise<runtime.ApiResponse<DigitizingserviceMelcoDigitizingModelsOrderResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling digitizeTempCompleteOrder.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/digitize/tempordercomplete/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DigitizingserviceMelcoDigitizingModelsTempOrderCompleteRequestToJSON(requestParameters.digitizingserviceMelcoDigitizingModelsTempOrderCompleteRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DigitizingserviceMelcoDigitizingModelsOrderResponseFromJSON(jsonValue));
    }

    /**
     */
    async digitizeTempCompleteOrder(requestParameters: DigitizingServiceOrdersApiDigitizeTempCompleteOrderRequest): Promise<DigitizingserviceMelcoDigitizingModelsOrderResponse> {
        const response = await this.digitizeTempCompleteOrderRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async digitizeUpdateRaw(requestParameters: DigitizingServiceOrdersApiDigitizeUpdateRequest): Promise<runtime.ApiResponse<DigitizingserviceMelcoDigitizingModelsOrderResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling digitizeUpdate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/digitize/orders/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DigitizingserviceMelcoDigitizingModelsOrderSaveToJSON(requestParameters.digitizingserviceMelcoDigitizingModelsOrderSave),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DigitizingserviceMelcoDigitizingModelsOrderResponseFromJSON(jsonValue));
    }

    /**
     */
    async digitizeUpdate(requestParameters: DigitizingServiceOrdersApiDigitizeUpdateRequest): Promise<DigitizingserviceMelcoDigitizingModelsOrderResponse> {
        const response = await this.digitizeUpdateRaw(requestParameters);
        return await response.value();
    }

}
